import React from 'react';

import config from '../../../../../../config';
import localization from '../../../shared/strings';
import UIBlocker from '../../../services/UiBlocker';
import Logger from '../../../services/Logger';
import { showDialog } from '../../../components/dialog';
import ValidateCardDialog from '../../../components/Billing/ValidateCardDialog';
import styles from './showValidateCardForm.module.scss';

export const VALIDATE_CARD_DIALOG_CANCELLED = 'ValidateCardFormDialogCancelled';

function showValidateCardForm(params) {
  return new Promise((res, rej) => {
    let error = '';

    if (!params) error = 'params is required.';
    if (!params.plan) error = 'params.plan is required.';
    if (!params.user) error = 'params.user is required.';

    const { email, useAlternativeStripeAccount } = params.user || {};
    if (!email) error = 'params.user.email is required.';

    if (error) {
      rej(new Error(error));
      return;
    }

    const stripePublicKey = useAlternativeStripeAccount
      ? config.payments.stripe.alternativePublishableKey
      : config.payments.stripe.publishableKey;

    Logger.log('UI', 'ValidateCardFormDialog');

    let closeDialog;
    let isClosed = false;
    const cleanup = () => {
      if (isClosed) return false;
      isClosed = true;
      if (typeof closeDialog === 'function') {
        closeDialog();
      }
      UIBlocker.unblock();
      return true;
    };

    const onRejectRequest = (message) => {
      if (!cleanup()) return;
      rej(new Error(message || localization.BILLING.textCantValidateCard));
    };

    const onResolveRequest = (token) => {
      if (!cleanup()) return;
      if (!token) {
        rej(new Error(localization.BILLING.textCantValidateCard));
        return;
      }
      res(token);
    };

    closeDialog = showDialog({
      title: params?.formTitle || localization.BILLING.editCardDetails,
      className: styles.validateCardDialog,
      textBtnCancel: null,
      textBtnOk: null,
      isCloseButtonShown: true,
      onCancel: () => onRejectRequest(VALIDATE_CARD_DIALOG_CANCELLED),
      onClose: () => onRejectRequest(VALIDATE_CARD_DIALOG_CANCELLED),
      children: (
        <ValidateCardDialog
          publishableKey={stripePublicKey}
          appearance={config.payments?.stripe?.appearance}
          email={email}
          submitLabel={params.submitLabel}
          onCancel={() => onRejectRequest(VALIDATE_CARD_DIALOG_CANCELLED)}
          onSuccess={onResolveRequest}
        />
      ),
    });

    UIBlocker.unblock();
  });
}

export default showValidateCardForm;
